import { atom } from 'recoil'

import { capacitorPreferencesEffect } from '@/capacitor/recoil/capacitor-preferences-effect'

export enum BiometricsAppPermission {
  /** Prompt biometrics permission to user (show biometricsPermission.page.tsx) */
  PROMPT = 'PROMPT',
  /** User denied biometrics */
  DENIED = 'denied',
  /** User granted biometrics */
  GRANTED = 'granted',
  /** User skipped biometrics prompt */
  SKIPPED = 'skipped',
}

const key = '@app/biometric-app-permission'
const biometricPermissionAtom = atom<BiometricsAppPermission | null>({
  key,
  default: null,
  effects: [capacitorPreferencesEffect(key, BiometricsAppPermission.PROMPT)],
})

export { biometricPermissionAtom }
